import { render, staticRenderFns } from "./DrugItem.vue?vue&type=template&id=bdafddac&scoped=true&lang=pug&"
import script from "./DrugItem.vue?vue&type=script&lang=ts&"
export * from "./DrugItem.vue?vue&type=script&lang=ts&"
import style0 from "./DrugItem.vue?vue&type=style&index=0&id=bdafddac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdafddac",
  null
  
)

export default component.exports